import React from 'react';

import {
  MenuItem,
  Select,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import * as selectorsChild from '../selector';

import { childSlice } from '@/domain/child/redux';

const Child: React.FC = () => {
  const child = useSelector(selectorsChild.selectedChildSelector);
  const childList = useSelector(selectorsChild.childListSelector);
  const dispatch = useDispatch();
  if (child) {
    if (childList.length === 1) {
      return (
        <div style={{ marginLeft: '20px' }}>
          <span>{`${child.name} さん`}</span>
        </div>
      );
    }
    return (
      <div style={{ marginLeft: '20px' }}>
        <Select
          value={child.childId}
          onChange={(e) => {
            for (let i = 0; i < childList.length; i += 1) {
              if (childList[i].childId === e.target.value) {
                dispatch(childSlice.actions.setChildId(e.target.value));
                return;
              }
            }
          }}
          style={{ backgroundColor: 'white', height: '36px' }}
        >
          {childList.map((c) => (
            <MenuItem value={c.childId} key={c.childId}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
        <span style={{ marginLeft: '10px' }}>さん</span>
      </div>
    );
  }
  return null;
};

export default Child;
